import React, {ReactNode} from 'react';

import Grid from '@material-ui/core/Grid';
import {useTranslation} from 'react-i18next';

import {ContentColumnsData, ContentColumnsProps, Map} from '../index';

import {ContentColumnElement, ContentColumnText, ContentColumnTitle} from './styled';

const renderItem = (obj: Map, tNameSpace?: string) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {t} = useTranslation();
    const elements = Object.keys(obj).map((key: string, index: number) => (
        <ContentColumnElement key={index}>
            <ContentColumnTitle>{tNameSpace ? t(`${tNameSpace}.${key}`) : key}</ContentColumnTitle>
            <ContentColumnText highlighted>{obj[key]}</ContentColumnText>
        </ContentColumnElement>
    ));
    return (
        <Grid item xs={12} md={4}>
            {elements}
        </Grid>
    );
};

const renderItems = (elements: ContentColumnsData, tNameSpace?: string): ReactNode =>
    Array.isArray(elements)
        ? elements.map((el: ContentColumnsData) => {
              if (Array.isArray(el)) return renderItems(el, tNameSpace);
              return renderItem(el, tNameSpace);
          })
        : renderItem(elements, tNameSpace);

export const ContentColumns = (props: ContentColumnsProps) => {
    const {tNameSpace, data} = props;
    return <Grid container>{renderItems(data, tNameSpace)}</Grid>;
};
